


















































































































import { Component, Vue } from 'vue-property-decorator';
import RequestUtil from '../utilities/request.util';
import { ILoginResponseSuccess } from '../interfaces';
import config from '../config';

@Component
export default class LoginComponent extends Vue {
  public LASSO_HOME_URL = config.LASSO_HOME_URL;

  public socialProviders = ['facebook', 'google', 'windows'];

  public fields = {
    username: '',
    password: '',
    authCode: '',
  };

  public step = 1;

  public errorMessage = '';

  public isLoading = false;

  isFormValid(): boolean {
    switch (this.step) {
      case 1: return this.fields.username !== '';
      case 2: return this.fields.password !== '';
      case 3: return this.fields.authCode !== '';
      default: return false;
    }
  }

  next(): void {
    this.errorMessage = '';
    if (this.isFormValid()) {
      this.step += 1;
    }
  }

  submit(): void {
    const canProceed = (this.step === 1) || (this.step === 2 && this.shouldVerifyAuthCode());

    if (canProceed) {
      this.next();
    } else if (this.isFormValid()) {
      this.loginRequest()
        .then(() => this.handleSuccessfulAttempt())
        .catch(() => this.handleUnsuccessfulAttempt());
    }
  }

  loginRequest(): Promise<ILoginResponseSuccess> {
    this.isLoading = true;
    return RequestUtil.post('auth', this.fields);
  }

  handleSuccessfulAttempt(): void {
    window.location.href = this.successfulLoginRedirectURI;

    setTimeout(() => {
      this.isLoading = false;
      this.step = 4;
    }, 1500);
  }

  handleUnsuccessfulAttempt(): void {
    this.isLoading = false;
    this.step = 1;
    this.fields.username = '';
    this.fields.password = '';
    this.errorMessage = this.$t('MESSAGES.UNSUCCESSFUL_LOGIN').toString();
  }

  shouldVerifyAuthCode(): boolean {
    // TODO: update logic to handle edge cases
    return this.fields.username.length > 0 && /^\d+$/.test(this.fields.username.trim());
  }

  getAuthCodeMessage(): string {
    return this.$t('MESSAGES.AUTH_CODE_SENT', {
      code: `<strong>${this.fields.username.slice(-4)}</strong>`,
    }).toString();
  }

  // eslint-disable-next-line class-methods-use-this
  handleSocialLogin(): void {
    // ...
  }

  get successfulLoginRedirectURI(): string {
    const queryParams = this.$route.query || {};
    const redirectTo = queryParams?.redirect_uri || '';
    return redirectTo.toString() || config.LASSO_HOME_URL;
  }

  get footerLink(): string {
    return this.LASSO_HOME_URL
      .replace(/https?:\/\//, '')
      .replace(/\/.*/, '');
  }
}
